import React from "react";

export default function HivPortal() {
  const data = []; // empty data like screenshot

  return (
    <div style={{ padding: "0 0 24px 0" }}>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>हिंव पोर्टल</h2>
        <div style={{ color: "#6c757d" }}>
          सांगली जिल्हा परिषद / हिंव पोर्टल
        </div>
      </div>

      {/* Card */}
      <div
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 6,
          marginTop: 10,
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        {/* Top Controls */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 15,
          }}
        >
          <div>
            <button className="btn">Copy</button>
            <button className="btn">Excel</button>
            <button className="btn">Print</button>
          </div>

          <div>
            Search:{" "}
            <input
              type="text"
              style={{
                padding: 6,
                border: "1px solid #ccc",
                borderRadius: 4,
              }}
            />
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead style={{ background: "#f1f1f1" }}>
              <tr>
                <th className="th">#</th>
                <th className="th">Description</th>
                <th className="th">File</th>
                <th className="th">Status</th>
                <th className="th">Remark</th>
                <th className="th">Created At</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      textAlign: "center",
                      padding: 20,
                      background: "#eef2f5",
                    }}
                  >
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <div>Showing 0 to 0 of 0 entries</div>

          <div>
            <button className="pageBtn">Previous</button>
            <button className="pageBtn">Next</button>
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .btn {
          background: #6c757d;
          color: white;
          border: none;
          padding: 6px 12px;
          margin-right: 5px;
          border-radius: 4px;
          cursor: pointer;
        }

        .btn:hover {
          background: #5a6268;
        }

        .th {
          border: 1px solid #ccc;
          padding: 10px;
          text-align: left;
        }

        .pageBtn {
          padding: 5px 12px;
          margin-left: 5px;
          border: 1px solid #ccc;
          background: white;
          cursor: pointer;
          border-radius: 4px;
        }

        .pageBtn:hover {
          background: #f1f1f1;
        }
      `}</style>
    </div>
  );
}